import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import CloseIcon from '@material-ui/icons/Close';
import { ModalHeader } from 'reactstrap';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Laperut from './Inputs/Laperut' 
import DateRangeComponent from './Inputs/DateRangeComponent' 
import FunctionsList from './Inputs/FunctionsList' 
import AvtalType from './Inputs/AvtalType' 
import Kunddatatyp from './Inputs/Kunddatatyp';
import LevrantorRapport from './Inputs/LevrantorRapport' 
import EsigneringStatus from './Inputs/EsigneringStatus' 
import ArendeStatus from './Inputs/ArendeStatus' 
import ArendeTyp from './Inputs/ArendeTyp' 
import ArendeKategori from './Inputs/ArendeKategori' 
import ArendeFaktura from './Inputs/ArendeFaktura' 
import SelectProjekt from './Inputs/SelectProjekt' 
import SelectAvtalToken from './Inputs/SelectAvtalToken' 
import SelectAvtalInvoiceStatus from './Inputs/SelectAvtalInvoiceStatus' 
import SelectKunderTag from './Inputs/SelectKunderTag' 
import SelectKunderDistrikt from './Inputs/SelectKunderDistrikt' 
import SelectKontakterTag from './Inputs/SelectKontakterTag' 
import SelectKunderType from './Inputs/SelectKunderType' 
import OrderStatus from './Inputs/OrderStatus' 
import MinaBarnList from './Inputs/MinaBarnList' 
import MinaBarnUsersList from './Inputs/MinaBarnUsersList' 
import ArtilkarTagg from './Inputs/ArtilkarTagg' 
import SelectProspektToken from './Inputs/SelectProspektToken' 
import MedLopande from './Inputs/MedLopande' 
import Fakturaintervall from './Inputs/Fakturaintervall' 
import WithLeverantor from './Inputs/WithLeverantor' 
import AccountTagg from './Inputs/AccountTagg'
import DialerRinglistor from './Inputs/DialerRinglistor'
import ChipsList from './ChipsList'
import AnpassadRapportR from './AnpassadRapportR'
import RapportV2 from '../RapportV2'
import {Divider,TextField,Button} from '@material-ui/core'
import { isEmpty,isUndefined} from 'lodash'
import {getRapport,resetCurrentObjekt,onCloseRapportToaster,getDialerRapport1} from 'actions'
import Tooltip from '@material-ui/core/Tooltip';
import Alert from '@material-ui/lab/Alert';
import KundAutoComplete from '../KundAutoComplete'
import NotyfileToaster from '../../../components/NotyfileToaster'
import IntlMessages from 'util/IntlMessages';
import compose from 'recompose/compose';
import { injectIntl } from 'react-intl';
const styles = (theme) => ({
    root: {
        padding: theme.spacing(2),
        margin: theme.spacing(4),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);

function mapStateToProps({auth,accountsData,RingList}) {
    const { Userlista,AvtalTyp,Flags,isIamChild,ResponseRapportMsg,AktivaKunder } = accountsData;
    const { authUser } = auth;
    const { RingListorA } = RingList;
    return {
        Userlista,authUser,AvtalTyp,Flags,isIamChild,ResponseRapportMsg,AktivaKunder,RingListorA
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getRapport:(Afid,userid,Filterstate,VisaFilterIExcel,SendTo)=>dispatch(getRapport(Afid,userid,Filterstate,VisaFilterIExcel,SendTo)),       
        getDialerRapport1:(Afid,userid,Kampanj,sendTo)=>dispatch(getDialerRapport1(Afid,userid,Kampanj,sendTo)),       
        resetCurrentObjekt:()=>  dispatch(resetCurrentObjekt()),     
        onCloseRapportToaster:()=>  dispatch(onCloseRapportToaster()),     
    };
}

class RapportPopUp extends Component {
    handleClose = () => {
        this.props.onClosePopUP()
    };
    state={
        Filterstate:[],
        VisaFilterIExcel:false,
        SendTo:"",
        OpenAnpassadRapport:false,
        OpenAvanceradRapport:false,
    }
        
    onChangeHandle=(Meta,Value,Meta1,Value1)=>{
    if(!isUndefined(Meta1)){
        let Item1={
            Meta:Meta,
            Value:Value
        }
        let Item2={
            Meta:Meta1,
            Value:Value1
        }
        let arr =[]
        arr.push(Item1)
        arr = arr.filter(n=>{return n.Meta !==Meta1})
        arr.push(Item2)
        this.setState({
            Filterstate:arr         
        })
    }else{
        let Item1={
            Meta:Meta,
            Value:Value
        }
        let arr =[]
        arr.push(Item1)
        this.setState({
            Filterstate:arr  
        })
    }
}
    onChangeHandle1SelectKund=(selectedKund)=>{
        this.onChangeHandle1("Kund",selectedKund)
    }
    ChangeVisaFilterIExcel=(e)=>{
        this.setState({
            VisaFilterIExcel:e.target.checked  
        })
    }
    onChangeHandle1=(Meta,Value,Meta1,Value1)=>{
    if(!isUndefined(Meta1)){
        let Item1={
            Meta:Meta,
            Value:Value
        }
        let Item2={
            Meta:Meta1,
            Value:Value1
        }
        let arr = isEmpty(this.state.Filterstate)?[]:this.state.Filterstate.filter(n=>{return n.Meta !==Meta})
        arr.push(Item1)
        arr.push(Item2)
        this.setState({
            Filterstate:arr         
        })
    }else{
        let Item1={
            Meta:Meta,
            Value:Value
        }
        let arr = isEmpty(this.state.Filterstate)?[]:this.state.Filterstate.filter(n=>{return n.Meta !==Meta})
        arr = arr.filter(n=>{return n.Meta !==Meta})
        if(Meta === "Avtalstyp" || Meta ==="Prospekttyp"){
            arr =arr.filter(n=>{return n.Meta !== "Leverantör"})
        }
        if(Meta === "Konton"){
            arr =arr.filter(n=>{return n.Meta !== "KontonUser"})
            arr =arr.filter(n=>{return n.Meta !== "OrderStatus"})
        }
        arr.push(Item1)
        this.setState({
            Filterstate:arr  
        })
    }
}
handleDeleteOptions=(item)=>{
    let OptionsList = this.state.Filterstate.filter(n=>{return n !==item})
    this.setState({
        ...this.state,
        Filterstate:OptionsList
    })
}
getRinglistaName = (KId)=>{
    let Ringlist = this.props.RingListorA.find(item=>parseInt(item.id) === parseInt(KId))?.KampanjName
    return Ringlist
}

RapportBythis=()=>{
    const Afid = this.props.authUser.user_Afid;
    const MainUser = this.props.authUser.user_id;
    if(isEmpty(this.state.Filterstate.filter(item=>{return item.Value === "Dialer"}))){
        this.props.getRapport(Afid,MainUser,this.state.Filterstate,this.state.VisaFilterIExcel,this.state.SendTo)  
    }else{
        let Kompanj= this.state.Filterstate.filter(item=>{return item.Meta === "Ringlista"})
        console.log(Kompanj)
        if(!isEmpty(Kompanj)){
            let Ringlist = {
                Rignlist:{
                    KampanjName:this.getRinglistaName(Kompanj[0].Value),
                    id:Kompanj[0].Value
                }
            }
            this.props.getDialerRapport1(Afid,MainUser,Ringlist,this.state.SendTo)
        }        
    }
    
    this.handleClose()  
}
onChangeHandleMulti=(Meta,Value)=>{
    
    let OptionsList = isEmpty(this.state.Filterstate)?[]:this.state.Filterstate
   
    if(!OptionsList.some(item => (item.Meta===Meta && item.Value===Value))){
        let newItem ={
            Meta:Meta,
            Value:Value
        }
       
        OptionsList.push(newItem)
        }
    
    this.setState({
        Filterstate:OptionsList
    })
}
onChangeHandle2=(Meta,Value)=>{
    let OptionsList = this.state.Filterstate.filter(n=>{return n.Meta !==Meta})
    this.setState({
        ...this.state,
        Filterstate:OptionsList
    })
}
componentDidMount=()=>{    
    this.setState({
        OpenAnpassadRapport:false,
      //  OpenRapportPopUp:true
    })
}
OpenAvanceradRapportPopUp = ()=>{
    this.setState({
        OpenAvanceradRapport:true,
    })
    this.handleClose()
}
CloseAvanceradRapportPopUp=()=>{
    this.setState({
        OpenAvanceradRapport:false,
    })
}
OpenAnpassadRapportPopUp=()=>{
    this.props.resetCurrentObjekt()
    this.setState({
        OpenAnpassadRapport:true,
    })
    this.handleClose()
}
CloseAnpassadRapportPopUp=()=>{
    this.setState({
        OpenAnpassadRapport:false,
    //    OpenRapportPopUp:false
    })
}
isEmail =(Email)=>{
    var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    if (Email.match(validRegex)) {return true;} 
    else {return false;}
}
render() {
    const Sendplaceholder = this.props.intl.formatMessage({ id: 'Send.to.Email.placeHolder' });
    const StartLabel = this.props.intl.formatMessage({ id: 'Input.date.start.label' });
    const CreateddatumLabel = this.props.intl.formatMessage({ id: 'Chips.Createddatum' });
    const datumLabel = this.props.intl.formatMessage({ id: 'Input.date' });
    const RegdateLabel = this.props.intl.formatMessage({ id: 'Regesitering.Date' });
    const PeriodLabel = this.props.intl.formatMessage({ id: 'input.Date.Period' });
    const RenegoLabel = this.props.intl.formatMessage({ id: 'Chips.Renegotiation' });
    const BookedLabel = this.props.intl.formatMessage({ id: 'Chips.Booked.date' });
    const CanceledLabel = this.props.intl.formatMessage({ id: 'Chips.Canceled.date' });
    const LatestEventLabel = this.props.intl.formatMessage({ id: 'Chips.Reports.Latest.events' });
    let Meta = isEmpty(this.state.Filterstate.filter(
        item=>{return item.Meta === "Avtalstyp" || item.Meta==="Prospekttyp"}
    ))?"":this.state.Filterstate.filter(
        item=>{return item.Meta === "Avtalstyp" || item.Meta==="Prospekttyp"}
    )[0].Value
     return (
            <>
            <Dialog open={this.props.openRapport} 
              onClose={this.handleClose} 
              aria-labelledby="customized-dialog-title" 
              fullWidth={true} 
              maxWidth={"xs"}>
                <ModalHeader className="modal-box-header bg-primary text-white">
                <IntlMessages id="Report"/>
                    <IconButton className="text-white"
                        onClick={this.handleClose}>
                        <CloseIcon />
                    </IconButton>
                </ModalHeader>
                <DialogContent dividers>
                <div className="row" style={{ height: 'auto', paddingTop: '10px' }}>
                <div className="col-12">
                    <FunctionsList
                    handleChange={this.onChangeHandle}
                    Flags={this.props.Flags}
                    userRole={this.props.authUser.user_role}
                    userLicans={this.props.authUser.user_Licans}
                    />
                </div>
                </div>
                {/*
                .filter(item=>{return !isEmpty(item.UserEmail)})
                // !isEmpty(this.state.Filterstate.filter(item=>{return item.Value === "Order"}))?
                */}
               
                {   
                 !isEmpty(this.state.Filterstate.filter(item=>{return item.Value === "Dialer"}))?"":                
                    parseInt(this.props.isIamChild)===1?
                    !isEmpty(this.state.Filterstate.filter(item=>{return item.Meta === "Rapport"}))?
                    <>
                    <div className="row" style={{ height: 'auto', paddingTop: '10px' }}>
                    <div className="col-12">
                        <MinaBarnList
                        handleChange={this.onChangeHandle1}
                        />
                    </div>
                  
                    </div>
                    <div className="row" style={{ height: 'auto', paddingTop: '10px' }}>
                    <div className="col-12">  {
                      !isEmpty(this.state.Filterstate.filter(item=>{return item.Meta === "Konton" && item.Value !=='-1'}))?  
                      <MinaBarnUsersList
                      handleChange={this.onChangeHandle1}
                      />
                      :""
                    }</div>
                    </div>
                    </>
                    :""
                    :
                    this.props.authUser.user_role === 1?
                        <div className="row" style={{ height: 'auto', paddingTop: '10px' }}>
                        <div className="col-12">
                            <TextField
                            variant="outlined"
                            fullWidth
                            label={<IntlMessages id="appKontoModule.Owner"/>}
                            size="small"
                            name="Ansvarig"
                            select
                            value={this.state.ansvarig}
                            SelectProps={{native: true,}}
                            InputLabelProps={{shrink: true,}}
                            onChange={(e)=>this.onChangeHandle1("ansvarig",e.target.value)}
                            >
                            <option key={0} value={0}><IntlMessages id="Choose"/></option>
                            <option key={-1} value={-1}><IntlMessages id="All"/></option>
                        {            
                            !isEmpty(this.props.Userlista)?
                            this.props.Userlista.map((option) => (
                                <Tooltip key={option.id} title={isEmpty(option.UserEmail)?<IntlMessages id="Customer.InActiv"/>:""} placement="left">                                    
                                <option value={option.id} style={{ background:isEmpty(option.UserEmail)?"#e6e6e6":""}}>
                                    {option.FirstName} {option.LastName}
                                </option>
                                
                                </Tooltip>
                            )):""}
                        </TextField>  
                        </div>
                        </div>
                    :
                    this.props.authUser.user_role === 1?
                        <div className="row" style={{ height: 'auto', paddingTop: '10px' }}>
                        <div className="col-12">
                            <TextField
                            variant="outlined"
                            fullWidth
                            label={<IntlMessages id="appKontoModule.Owner"/>}
                            size="small"
                            name="Ansvarig"
                            select
                            value={this.state.ansvarig}
                            SelectProps={{native: true,}}
                            InputLabelProps={{shrink: true,}}
                            onChange={(e)=>this.onChangeHandle1("ansvarig",e.target.value)}
                            >
                            <option key={0} value={0}><IntlMessages id="Choose"/></option>
                            <option key={-1} value={-1}><IntlMessages id="All"/></option>
                        {            
                            !isEmpty(this.props.Userlista)?
                            this.props.Userlista.map((option) => (
                                 <Tooltip key={option.id} title={isEmpty(option.UserEmail)?<IntlMessages id="Customer.InActiv"/>:""} placement="left">
                                    <option  value={option.id} style={{ background:isEmpty(option.UserEmail)?"#e6e6e6":""}}>
                                   {option.FirstName} {option.LastName}
                                </option>
                                </Tooltip>
                            )):""}
                        </TextField>  
                        </div>
                        </div>
                        :""

                }




                
{
    !isEmpty(this.state.Filterstate.filter(item=>{return item.Value === "Ärende"}))?
    <>
    <ArendeStatus
    onChangeHandleMulti={this.onChangeHandleMulti}    
    />
    <ArendeTyp
    onChangeHandleMulti={this.onChangeHandleMulti}
    />
    <ArendeKategori
    onChangeHandleMulti={this.onChangeHandleMulti}
    />
    <ArendeFaktura
    onChangeHandleMulti={this.onChangeHandleMulti}
    />
    <AccountTagg
    Meta={"Tagg"}
    handleChange={this.onChangeHandleMulti}
    />
    </>
    :
    ""
}
{
    !isEmpty(this.state.Filterstate.filter(item=>{return item.Value === "Projekt Tidsrapport"}))?
    <>
    <SelectProjekt
    onChangeHandleMulti={this.onChangeHandleMulti}
    />
    </>
    :
    ""
}
{
    !isEmpty(this.state.Filterstate.filter(item=>{return item.Value === "E-signering"}))?
    <>
    <div className="row" style={{ height: 'auto', paddingTop: '10px' }}>
    <div className='col-12'>
   <EsigneringStatus
    onChangeHandleMulti={this.onChangeHandleMulti}    
    />
    </div>
    </div>
    <div className="row" style={{ height: 'auto', paddingTop: '10px' }}>
    <div className='col-12'>
     <DateRangeComponent
     Meta={"SenasEventDatum"}
     Label={LatestEventLabel}
     handleChange={this.onChangeHandle1}
     withOutAll={0}
     />
     </div>
     </div>
    </>
    :
    ""
}
{
    !isEmpty(this.state.Filterstate.filter(item=>{return item.Value === "Avtal" || item.Value==="Prospekt"}))?
    <>
    <AvtalType
    onChangeHandleMulti={this.onChangeHandle1}
    isAvtal={this.state.Filterstate.filter(item=>{return item.Value === "Avtal"}).length === 1?1:0}
    />
    {
        !isEmpty(this.state.Filterstate.filter(
            item=>{return item.Meta === "Avtalstyp" || item.Meta ==="Prospekttyp"}
        ))?
            !isEmpty(this.props.AvtalTyp.filter(item =>{                
                return item.type === Meta
            })[0].Operator)?
            <LevrantorRapport
            Options={this.props.AvtalTyp.filter(item =>{                
                return item.type === Meta
            })[0].Operator}
            onChangeHandleMulti={this.onChangeHandleMulti}
            onChangeHandle={this.onChangeHandle2}
            />
            :""        
        :""
       
    }
    </>
    :
    ""
}

{//
    !isEmpty(this.state.Filterstate.filter(item=>{return item.Value === "Order"  || item.Value ==="Order artiklar" || item.Value ==="Order med artiklar"}))?
    <>
    <div className="row" style={{ height: 'auto', paddingTop: '10px' }}>
        <div className='col-12'>
     <KundAutoComplete
     isFromRapport={true}
     selectthisKund={this.onChangeHandle1SelectKund}
     /></div>
      <div className='col-12'>
     <OrderStatus
     onChangeHandle={this.onChangeHandle1}
     /></div>
      <div className='col-12'>
     <ArtilkarTagg
    onChangeHandle={this.onChangeHandle1}
    /></div>
    </div>
    </>
    :""
}
{
  !isEmpty(this.state.Filterstate.filter(item=>{return item.Value === "Order kunddata"}))?
  <>
    <div className="row" style={{ height: 'auto', paddingTop: '10px' }}>
      <div className='col-12'>
      <KundAutoComplete
      selectthisKund={this.onChangeHandle1SelectKund}
      /></div>
      <div className='col-12'>
      <OrderStatus
        onChangeHandle={this.onChangeHandle1}
      /></div>
      <div className='col-12'>
      <Kunddatatyp
        onChangeHandle={this.onChangeHandle1}
      />
      </div>
    </div>
  </>
  :""
}
{
    !isEmpty(this.state.Filterstate.filter(item=>{return item.Value === "Avtal"})) ?
    <>
    <SelectAvtalToken
    onChangeHandleMulti={this.onChangeHandle1}
    />
    <SelectAvtalInvoiceStatus
    onChangeHandle={this.onChangeHandle1}
    />
    <MedLopande
    onChangeHandle={this.onChangeHandle1}
    />
    <Fakturaintervall
    onChangeHandle={this.onChangeHandle1}
    />
    </>
    :""
}
{
     !isEmpty(this.state.Filterstate.filter(item=>{return item.Value === "Fakturor"}))?
     <div className="row" style={{ height: 'auto', paddingTop: '10px' }}>
        <div className="col-12"  style={{ height: 'auto', paddingTop: '10px' }}>
    <SelectAvtalInvoiceStatus
    onChangeHandle={this.onChangeHandle1}
    /></div>
    </div>
     :""
}
{
    !isEmpty(this.state.Filterstate.filter(item=>{return item.Value === "Kunder"}))?
    <SelectKunderTag
    onChangeHandleMulti={this.onChangeHandle1}
    />
    :""
}
{
    !isEmpty(this.state.Filterstate.filter(item=>{return item.Value === "Kunder"}))?
    //Dölj Distrikt
    parseInt(this.props.authUser.user_Licans) === 1 || parseInt(this.props.authUser.user_Licans) === 2?"":
    parseInt(this.props.Flags.Distrikt) === 1?
    <SelectKunderDistrikt
    onChangeHandleMulti={this.onChangeHandle1}
    />
    :""
    :""
}

{
    !isEmpty(this.state.Filterstate.filter(item=>{return item.Value === "Kontaktpersoner"}))?
    <SelectKontakterTag
    onChangeHandleMulti={this.onChangeHandle1}
    />
    :""
}
{
    !isEmpty(this.state.Filterstate.filter(item=>{return item.Value === "Kunder"}))?
    <SelectKunderType
    onChangeHandle={this.onChangeHandle1}
    />
    :""
}
{
    !isEmpty(this.state.Filterstate.filter(item=>{return item.Value === "Prospekt"}))?
    <SelectProspektToken
    onChangeHandleMulti={this.onChangeHandle1}
    />
    :""
}
{/*
    !isEmpty(this.state.Filterstate.filter(item=>{return item.Value === "Prospekt"}))?
    <div className="row" style={{ height: 'auto', paddingTop: '10px' }}>
    <div className="col-12"  style={{ height: 'auto', paddingTop: '10px' }}>
                    <Laperut
                    Meta={"SkapadDatum"}
                    Label={<IntlMessages id="Chips.Createddatum" />}
                    handleChange={this.onChangeHandle1}
                    />
                </div>
            </div>
    :""*/
}
{
    /*Jack 2023-07-12*/
    !isEmpty(this.state.Filterstate.filter(item=>{return item.Value === "Avtal" || item.Value === "Prospekt" || item.Value === "Order" || item.Value === "Projekt"}))?
    <WithLeverantor
    onChangeHandleMulti={this.onChangeHandle1}
    />
    :""
}
{
    !isEmpty(this.state.Filterstate.filter(item=>{return item.Value === "Avtal"}))?
    <div className="row" style={{ height: 'auto', paddingTop: '10px' }}>
    <div className="col-12"  style={{ height: 'auto', paddingTop: '10px' }}>
                    <DateRangeComponent
                    Meta={"OmforDatum"}
                    Label={RenegoLabel}
                    handleChange={this.onChangeHandle1}
                    withOutAll={0}
                    />
                </div>
            </div>
    :""
    
}
{
    !isEmpty(this.state.Filterstate.filter(item=>{return item.Value === "Avtal"}))?
    <div className="row" style={{ height: 'auto', paddingTop: '10px' }}>
    <div className="col-12"  style={{ height: 'auto', paddingTop: '10px' }}>
                    <DateRangeComponent
                    Meta={"StartDatumAvtal"}
                    Label={StartLabel}
                    handleChange={this.onChangeHandle1}
                    withOutAll={0}
                    />
                </div>
            </div>
    :""
    
}
{
    !isEmpty(this.state.Filterstate.filter(item=>{return item.Value === "Moten"}))?
    <>
    <div className="row" style={{ height: 'auto', paddingTop: '10px' }}>
    <div className="col-12"  style={{ height: 'auto', paddingTop: '10px' }}>
                    <DateRangeComponent
                    Meta={"Datum"}
                    Label={CreateddatumLabel}
                    handleChange={this.onChangeHandle1}
                    withOutAll={0}
                    />
                </div>
            </div>
    <div className="row" style={{ height: 'auto', paddingTop: '10px' }}>
    <div className="col-12"  style={{ height: 'auto', paddingTop: '10px' }}>
                    <DateRangeComponent
                    Meta={"bokadDatum"}
                    Label={BookedLabel}
                    handleChange={this.onChangeHandle1}
                    withOutAll={0}
                    />
                </div>
            </div>
    <div className="row" style={{ height: 'auto', paddingTop: '10px' }}>
    <div className="col-12"  style={{ height: 'auto', paddingTop: '10px' }}>
                    <DateRangeComponent
                    Meta={"AvbokadDatum"}
                    Label={CanceledLabel}
                    handleChange={this.onChangeHandle1}
                    withOutAll={0}
                    />
                </div>
            </div>
            <div className="col-12"  style={{ height: 'auto', paddingTop: '10px' }}>
        <TextField
           fullWidth
           defaultValue=""
           variant="outlined"
           size="small"
           name="titl444e"
           label={<IntlMessages id="Send.To.Label"/>}
           value={this.state.SendTo}
           InputLabelProps={{ shrink: true }}
           onChange={(e)=>this.setState({
            ...this.state,
            SendTo:e.target.value
            })}
           />
    </div>
    <div className="col-12"  style={{ height: 'auto', paddingTop: '10px' }}>
   <FormControlLabel
   control={<Checkbox checked={this.state.VisaFilterIExcel} onChange={this.ChangeVisaFilterIExcel} name="VisaFilterIExcel" />}
   label={<IntlMessages id="Label.Show.filter" />}
   />
   </div>
   <div className="col-12"  style={{ height: 'auto', paddingTop: '10px' }}>
       {
           isEmpty(this.state.Filterstate.filter(item=>item.Meta.toUpperCase().indexOf("DATUM") > -1))?
           <Alert severity="error"><IntlMessages id="Warning.Report.Body" /></Alert>
           :""
       }
   </div>
    </>
    :
    !isEmpty(this.state.Filterstate.filter(item=>{return item.Value === "Avtalsfakturering"}))?
    <>
    <div className="row" style={{ height: 'auto', paddingTop: '10px' }}>
    <div className="col-12"  style={{ height: 'auto', paddingTop: '10px' }}>
                    <DateRangeComponent
                    Meta={"OmforDatum"}
                    Label={RenegoLabel}
                    handleChange={this.onChangeHandle1}
                    withOutAll={0}
                    />
                </div>
            </div>
    <div className="row" style={{ height: 'auto', paddingTop: '10px' }}>
    <div className="col-12"  style={{ height: 'auto', paddingTop: '10px' }}>
                    <DateRangeComponent
                    Meta={"StartDatum"}
                    Label={PeriodLabel}
                    handleChange={this.onChangeHandle1}
                    withOutAll={0}
                    />
                </div>
                <div className="col-12"  style={{ height: 'auto', paddingTop: '10px' }}>
        <TextField
           fullWidth
           defaultValue=""
           variant="outlined"
           size="small"
           name="titl444e"
           placeholder={Sendplaceholder}
           label={<IntlMessages id="Send.to.Email"/>}
           autocomplete="off"
           value={this.state.SendTo}
           InputLabelProps={{ shrink: true }}
           onChange={(e)=>this.setState({
            ...this.state,
            SendTo:e.target.value
            })}
            error={!this.isEmail(this.state.SendTo)}
           />
    </div>
   <div className="col-12"  style={{ height: 'auto', paddingTop: '10px' }}>
   <FormControlLabel
   control={<Checkbox checked={this.state.VisaFilterIExcel} onChange={this.ChangeVisaFilterIExcel} name="VisaFilterIExcel" />}
   label={<IntlMessages id="Label.Show.filter" />}
   />
   </div>
   <div className="col-12"  style={{ height: 'auto', paddingTop: '10px' }}>
       {
           isEmpty(this.state.Filterstate.filter(item=>item.Meta.toUpperCase().indexOf("DATUM") > -1))?
           <Alert severity="error"><IntlMessages id="Warning.Report.Body" /></Alert>
           :""
       }
   </div>
            </div>
    </>
    :
    !isEmpty(this.state.Filterstate.filter(item=>{return item.Value === "Order"  || item.Value ==="Order kunddata" || item.Value ==="Order artiklar" || item.Value ==="Order med artiklar"}))?
    <div className="row" style={{ height: 'auto', paddingTop: '10px' }}>
        <div className="col-12"  style={{ height: 'auto', paddingTop: '10px' }}>
            <DateRangeComponent
            Meta={"Datum"}
            Label={CreateddatumLabel}
            handleChange={this.onChangeHandle1}
            withOutAll={0}
            />
        </div>
        <div className="col-12"  style={{ height: 'auto', paddingTop: '10px' }}>
            <DateRangeComponent
            Meta={"RegDatum"}
            Label={RegdateLabel}
            handleChange={this.onChangeHandle1}
            withOutAll={0}
            />
        </div>
        <div className="col-12"  style={{ height: 'auto', paddingTop: '10px' }}>
        <TextField
           fullWidth
           defaultValue=""
           variant="outlined"
           size="small"
           name="titl444e"
           placeholder={Sendplaceholder}
           label={<IntlMessages id="Send.to.Email"/>}
           autocomplete="off"
           value={this.state.SendTo}
           InputLabelProps={{ shrink: true }}
           onChange={(e)=>this.setState({
            ...this.state,
            SendTo:e.target.value
            })}
            error={!this.isEmail(this.state.SendTo)}
           />
        </div>
    </div>
    :!isEmpty(this.state.Filterstate.filter(item=>{return item.Value === "Prospekt"}))?
    <div className="row" style={{ height: 'auto', paddingTop: '10px' }}>
    <div className="col-12"  style={{ height: 'auto', paddingTop: '10px' }}>
                    <DateRangeComponent
                    Meta={"SkapadDatum"}
                    Label={CreateddatumLabel}
                    handleChange={this.onChangeHandle1}
                    withOutAll={0}
                    />
                </div>
                <div className="col-12"  style={{ height: 'auto', paddingTop: '10px' }}>
        <TextField
           fullWidth
           defaultValue=""
           variant="outlined"
           size="small"
           name="titl444e"
           placeholder={Sendplaceholder}
           label={<IntlMessages id="Send.to.Email"/>}
           autocomplete="off"
           value={this.state.SendTo}
           InputLabelProps={{ shrink: true }}
           onChange={(e)=>this.setState({
            ...this.state,
            SendTo:e.target.value
            })}
            error={!this.isEmail(this.state.SendTo)}
           />
    </div>
            </div>
    :
    !isEmpty(this.state.Filterstate.filter(item=>{return item.Value === "Kontaktpersoner"}))
    ||
    !isEmpty(this.state.Filterstate.filter(item=>{return item.Value === "Kunder"}))
    ?
    <div className="row" style={{ height: 'auto', paddingTop: '10px' }}>
        <div className="col-12"  style={{ height: 'auto', paddingTop: '10px' }}>
            {/*DateRangeComponent*/}
            <DateRangeComponent
              Label={datumLabel}
              Meta={"Skapad datum"}
              handleChange={this.onChangeHandle1}
              withOutAll={1}
              />
        </div>
        <div className="col-12"  style={{ height: 'auto', paddingTop: '10px' }}>
        <TextField
           fullWidth
           defaultValue=""
           variant="outlined"
           size="small"
           name="titl444e"
           placeholder={Sendplaceholder}
           label={<IntlMessages id="Send.to.Email"/>}
           autocomplete="off"
           value={this.state.SendTo}
           InputLabelProps={{ shrink: true }}
           onChange={(e)=>this.setState({
            ...this.state,
            SendTo:e.target.value
            })}
            error={!this.isEmail(this.state.SendTo)}
           />
    </div>
   <div className="col-12"  style={{ height: 'auto', paddingTop: '10px' }}>
   <FormControlLabel
   control={<Checkbox checked={this.state.VisaFilterIExcel} onChange={this.ChangeVisaFilterIExcel} name="VisaFilterIExcel" />}
   label={<IntlMessages id="Label.Show.filter" />}
   />
   </div>
   <div className="col-12"  style={{ height: 'auto', paddingTop: '10px' }}>
       {
           isEmpty(this.state.Filterstate.filter(item=>item.Meta.toUpperCase().indexOf("DATUM") > -1))?
           <Alert severity="error"><IntlMessages id="Warning.Report.Body" /></Alert>
           :""
       }
   </div>
    </div>
    :
    <div className="row" style={{ height: 'auto', paddingTop: '10px' }}>
         {
                   !isEmpty(this.state.Filterstate.filter(item=>{return item.Value === "Dialer"}))?
                    <div className="col-12"  style={{ height: 'auto', paddingTop: '10px' }}>
                        {
                       // isEmpty(this.props.RingListorA)?"":
                        <DialerRinglistor
                        Meta={"Ringlist"}
                        handleChange={this.onChangeHandle1}
                        />
                        }
                    </div>
                   :
                   <div className="col-12"  style={{ height: 'auto', paddingTop: '10px' }}>
                   <DateRangeComponent
                   Meta={"Datum"}
                   Label={CreateddatumLabel}
                   handleChange={this.onChangeHandle1}
                   withOutAll={0}
                   />
               </div>
                }
    
    <div className="col-12"  style={{ height: 'auto', paddingTop: '10px' }}>
        <TextField
           fullWidth
           defaultValue=""
           variant="outlined"
           size="small"
           name="titl444e"
           placeholder={Sendplaceholder}
           label={<IntlMessages id="Send.to.Email"/>}
           autocomplete="off"
           value={this.state.SendTo}
           InputLabelProps={{ shrink: true }}
           onChange={(e)=>this.setState({
            ...this.state,
            SendTo:e.target.value
            })}
            error={!this.isEmail(this.state.SendTo)}
           />
    </div>
   <div className="col-12"  style={{ height: 'auto', paddingTop: '10px' }}>
   <FormControlLabel
   control={<Checkbox checked={this.state.VisaFilterIExcel} onChange={this.ChangeVisaFilterIExcel} name="VisaFilterIExcel" />}
   label={<IntlMessages id="Label.Show.filter" />}
   />
   </div>
   <div className="col-12"  style={{ height: 'auto', paddingTop: '10px' }}>
       {
        isEmpty(this.state.Filterstate.filter(item=>{return item.Value === "Dialer"}))?
           isEmpty(this.state.Filterstate.filter(item=>item.Meta.toUpperCase().indexOf("DATUM") > -1))?
           <Alert severity="error"><IntlMessages id="Warning.Report.Body" /></Alert>
           :""
           :""
       }
   </div>
</div>
}
{/*

            this.props.AvtalTyp.filter(item =>{
                let Meta = this.state.Filterstate.filter(item=>{return item.Value === "Avtalstyp" || item.Value==="Prospekttyp"})[0].Value
                return item.type === Meta
            })[0].Operator
            
*/}

            <Divider/>
                <div>
                   <ChipsList
                   Userlista={this.props.Userlista}
                   Chips={this.state.Filterstate}
                   handleDeleteOptions={this.handleDeleteOptions}
                   />
                </div>
                </DialogContent>
                <Divider/>
                <div className="d-flex my-2 mx-2">
                <div className="mr-auto">
                {
                    //Dölj anpassad rapport (Ambition,Essential)
                    parseInt(this.props.authUser.user_Licans) === 1 || parseInt(this.props.authUser.user_Licans) === 2?"":
                parseInt(this.props.authUser.user_role) === 5?"": 
                parseInt(this.props.authUser.user_RapportFlag) === 1?
                <Button 
                className="btn btn-link" 
                color="primary"
                onClick={this.OpenAvanceradRapportPopUp}
                >
                    <IntlMessages id="Label.Report.Advanced"/>
                </Button>  
                :
                <Button 
                className="btn btn-link" 
                color="primary"
                onClick={this.OpenAnpassadRapportPopUp}
                >
                    <IntlMessages id="Label.Report.Customized"/>
                </Button>  
                }      
                     
                </div>
                <div className="ml-auto">
                <Button
                variant="contained"
                color="primary"
                disabled={
                (
                    isEmpty(this.state.Filterstate.filter(item=>{return item.Value === "Dialer"})) 
                    &&
                    isEmpty(this.state.Filterstate.filter(item=>item.Meta.toUpperCase().indexOf("DATUM") > -1))
                )   
                    ||
                    !this.isEmail(this.state.SendTo)
                }
                className="jr-btn"
                onClick={this.RapportBythis}
                >
                    <IntlMessages id="Report"/>
                </Button>
                </div>  
                </div>
            </Dialog>   
            {
                this.state.OpenAnpassadRapport?
                <AnpassadRapportR
                OpenAnpassadRapport={this.state.OpenAnpassadRapport}
                CloseAnpassadRapportPopUp={this.CloseAnpassadRapportPopUp}
                />
                :""
            }
            {
                this.state.OpenAvanceradRapport === true?
                <RapportV2
                openRapport={this.state.OpenAvanceradRapport}
                onClosePopUP={this.CloseAvanceradRapportPopUp}
                />
                :""
            }
            {
                     isEmpty(this.props.ResponseRapportMsg)?"":
                      <NotyfileToaster
                      response={this.props.ResponseRapportMsg}
                      onCloseToaster={this.props.onCloseRapportToaster}
                      /> 
                      }
            </>
        );
    }
}

export default compose(connect(
    mapStateToProps,mapDispatchToProps
),injectIntl)(RapportPopUp);